import * as cuBuilding from "../building_pricing/pricingReducer";
import * as validate from "../../../Components/Modals/validations";
import { params, const_var } from "../reducer";
import * as cuComponent from "../building_component/componentReducer";
export const leadcustomerState = {
	showCustomerModal: false,
	showTermsCondition: false,
	searchData: {},
	searchType: "Leads",
	leadSourceData: {},
	showCustomerLeadRecord: false,
	LeadCustomerData: {},
	showEditEmail: false,
	LeadCustomerPostData: {},
	search_lead_customer: "",
	showInstallationAddressDetails: false,
	displayerrorMessage: "",
	i_g_A_y: true,
	is_module_name: "",
	addCustomerData: false,
	isShowSuccessOq: false,
	targetRedirectUrl: "",
	returnRespone: "",
	thankYouForSaveLater: false,
	alertUsedMSG: "",
	showAddressView: false,
	isAddress_Edit: "",
	has_customer_permission: "0",
	checkImageCount: [],
	checkCustomerEdit: false,
	leadSourceStateData: {},
	editOrderQuoteAlertBox: false,
	redirectvalue: "",
	redirectcrmflag: false,
	editId: 0,
	tempLeadCustomerAddress: {},
	editAddressIndex: null,
	editAddressType: "",
	editAddressShow: false,
	confirmationBoxShow: false,
	deleteAddressId: null,
	addAddressShow: false,
	copyKlinkText: "Copy Link",
	showSuccessModalButton: true,
	showMoreWithErr: false
};
leadcustomerState.leadSourceStateData = const_var.leadSourceStateData != "" && Object.keys(const_var.leadSourceStateData).length > 0 ? const_var.leadSourceStateData : leadcustomerState.leadSourceStateData;
leadcustomerState.displayerrorMessage = const_var.displayerrorMessage;
const_var.LeadCustomerData = leadcustomerState.LeadCustomerData;
leadcustomerState.is_module_name = const_var.crmSetting.is_module_name;
leadcustomerState.targetRedirectUrl = const_var.targetRedirectUrl;
leadcustomerState.targetRedirectUrl.web_url = const_var.crmSetting.web_url;
leadcustomerState.targetRedirectUrl.form_action = const_var.crmSetting.form_action;
leadcustomerState.lgnby = const_var.crmSetting.lgnby;
leadcustomerState.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
leadcustomerState.targetRedirectUrl.selected_sub_module = const_var.crmSetting.selected_sub_module;
leadcustomerState.has_customer_permission = const_var.crmSetting.has_customer_permission;
leadcustomerState.checkImageCount = const_var.i_g_A_y;
leadcustomerState.domain_url = const_var.crmSetting.domain_url;
leadcustomerState.lgnby = const_var.crmSetting.lgnby;
leadcustomerState.checkCustomerEdit = const_var.crmSetting.is_quote_Edit;
leadcustomerState.loggeedincrmflag = const_var.crmSetting.is_CRM == false && const_var.crmSetting.is_loggedin == true ? true : false;
leadcustomerState.loggeedincrmflagURL = const_var.crmSetting.page;

if (const_var.crmSetting.page.includes("senseicrm.com")) {
	leadcustomerState.redirectcrmflag = true;
}

const leadcustomerReducer = (state = leadcustomerState, action) => {
	const newState = { ...state };
	switch (action.type) {
		case "testAction":
			return {
				...state,
				action
			};
		case "onTextFiledChangeValue":
			state.LeadCustomerData[action.value] = action.event.target.value;
			state.LeadCustomerData.is_Action = false;
			const_var.LeadCustomerData[action.value] = action.event.target.value;

			if (action.ValidationCheck != "NoValidate") {
				validate.onTextFiledChangeValue(action.event, action.value, action.keyword, "LeadCustomer");
			}
			if (action.ValidationCheck == "NoValidate1") {
				validate.alphaSpaceValue(action.event, action.value);
			}
			if (action.ValidationCheck == "NoValidate2") {
				validate.alphaCheckValue(action.event, action.value);
			}
			if (action.editEmail == "editEmail") {
				state.LeadCustomerData.email_2 = action.event.target.value;
			}
			state.displayerrorMessage = const_var.displayerrorMessage;
			return {
				...state,
				action
			};
			break;
		case "editUserAddress":
			if (action.keyword === "is_default") {
				let newArr =
					state.LeadCustomerData?.address?.length > 0 &&
					state.LeadCustomerData?.address?.map((item, index) => {
						if (index === action.addressId) {
							if (action.from == "shipping") {
								item.is_installation = 1;
								item.is_billing = item.is_billing == 1 ? 1 : 0;
							} else {
								item.is_installation = item.is_installation == 1 ? 1 : 0;
								item.is_billing = 1;
							}
						} else {
							if (action.from == "shipping") {
								if (item.is_installation == 1) {
									item.is_installation = 0;
								}
							} else {
								if (item.is_billing == 1) {
									item.is_billing = 0;
								}
							}
						}
						return item;
					});
				state.LeadCustomerData.address = newArr;
				state.LeadCustomerData = state.LeadCustomerData;
			}
			if (action.keyword === "removeAddress") {
				if (state.confirmationBoxShow == false) {
					state.confirmationBoxShow = true;
					state.deleteAddressId = action.addressId;
				} else {
					if (state.LeadCustomerData?.address?.length > 1 && action.from == "delete") {
						let filter = state.LeadCustomerData.address.filter((item, index) => {
							if (index != state.deleteAddressId) {
								return item;
							}
						});
						state.LeadCustomerData["address"] = filter;
						const_var.LeadCustomerData = state.LeadCustomerData;
					}
					if (state.LeadCustomerData?.address?.length == 1) {
						state.LeadCustomerData.address[0]["is_default"] = 1;
						state.LeadCustomerData.address[0]["is_installation"] = 1;
						state.LeadCustomerData.address[0]["is_billing"] = 1;
					}
					state.confirmationBoxShow = false;
					state.deleteAddressId = null;
				}
			}

			return {
				...state,
				action
			};
			break;
		case "onAddressFiledChangeValue":
			let MainData = "";
			MainData = state.isAddress_Edit;
			if (state.editAddressShow && state.LeadCustomerData?.address?.length > 0) {
				let from = state.editAddressType == "installation" ? `shipping_${action.value}` : `billing_${action.value}`;
				let index = state.editAddressIndex;
				state.LeadCustomerData[from] = action.event.target.value;
				state.LeadCustomerData.address[index]["address_line_1"] = state.editAddressType == "installation" ? state.LeadCustomerData?.shipping_address_line_1 : state.LeadCustomerData?.billing_address_line_1;
				state.LeadCustomerData.address[index]["address_line_2"] = state.editAddressType == "installation" ? state.LeadCustomerData?.shipping_address_line_2 : state.LeadCustomerData?.billing_address_line_2;
				state.LeadCustomerData.address[index]["city"] = state.editAddressType == "installation" ? state.LeadCustomerData?.shipping_city : state.LeadCustomerData?.billing_city;
				state.LeadCustomerData.address[index]["county"] = state.editAddressType == "installation" ? state.LeadCustomerData?.shipping_county : state.LeadCustomerData?.billing_county;
				state.LeadCustomerData.address[index]["zipcode"] =
					state.editAddressType == "installation" ? state.LeadCustomerData?.shipping_zipcode.replace(/[^0-9]/g, "") : state.LeadCustomerData?.billing_zipcode.replace(/[^0-9]/g, "");
				state.LeadCustomerData.address[index]["state"] = state.editAddressType == "installation" ? state.LeadCustomerData?.shipping_state : state.LeadCustomerData?.billing_state;
				state.LeadCustomerData.address[index]["is_billing"] = state.editAddressType == "installation" ? 0 : 1;
				state.LeadCustomerData.address[index]["is_installation"] = state.editAddressType == "installation" ? 1 : 0;
				state.LeadCustomerData.address[index]["is_default"] = 1;
				if (state.LeadCustomerData?.address[index]?.id) {
					state.LeadCustomerData.address[index]["is_edit"] = 1;
				}
			} else {
				let type = action.from === "Installation" ? `shipping_${action.value}` : `billing_${action.value}`;
				state.LeadCustomerData[type] = action.keyword == "zipcode" ? action.event.target.value.replace(/[^0-9]/g, "") : action.event.target.value;
			}
			if (state.LeadCustomerData?.address?.length === 1) {
				state.LeadCustomerData.address[0]["is_billing"] = 1;
				state.LeadCustomerData.address[0]["is_installation"] = 1;
				state.LeadCustomerData.address[0]["is_default"] = 1;
			}
			const_var.LeadCustomerData = state.LeadCustomerData;
			state.LeadCustomerData.is_Action = false;
			if (action.ValidationCheck == "NoValidate1") {
				validate.alphaSpaceValue(action.event, action.value);
			}
			if (action.ValidationCheck == "NoValidate2") {
				validate.alphaCheckValue(action.event, action.value);
			}
			state.displayerrorMessage = const_var.displayerrorMessage;
			return {
				...state,
				action
			};
			break;
		case "handleProductModal":
			if (params.isShowCenter || params.is_translusant) {
				params.isShowCenter = false;
				params.is_translusant = false;
				cuBuilding.BuildingUpdate(true, "");
				if (params.add_front_lean) cuBuilding.UpdateFrontLean();
				if (params.add_left_lean) cuBuilding.UpdateLeftLean();
				if (params.add_right_lean) cuBuilding.UpdateRightLean();
				if (params.add_back_lean) cuBuilding.UpdateBackLean();
			}
			state.alertUsedMSG = "";
			state.thankYouForSaveLater = false;
			const_var.controls.target.set(0, params.p_h / 2, 0);
			const_var.camera.position.set(0, params.p_h + 0, 3.25 * params.p_d);
			const_var.controls.update();
			state.returnRespone = "";
			state.showCustomerModal = false;
			state.isShowSuccessOq = true;
			state.i_g_A_y = false;
			if (const_var.checkCaptuareImage != true) {
				const_var.checkIval = 0;
				const_var.i_g_A_y = [];
			}
			const_var.selectedTabKeyForWheel = "capture";

			let checkBodyThyumb = document.querySelector("body");
			if (checkBodyThyumb.classList.contains("activethumb-view")) {
				checkBodyThyumb.classList.remove("active-offset-thumbnail");
				const_var.ClickforPhotosMobile.current.click();
				setTimeout(() => {
					const_var.activeTab = "buildingtypetab";
					cuComponent.TsCeSot("quote", "finalsubmit");
				}, 500);
			} else {
				const_var.activeTab = "buildingtypetab";
				cuComponent.TsCeSot("quote", "finalsubmit");
			}

			//}
			return {
				...state,
				action
			};
			break;
		case "showMoreWithErr":
			state.showMoreWithErr = action.value;
			return {
				...state,
				action
			};
			break;
		case "AddEditAddressInfo":
			if (action.key == "edit") {
				const_var.TempLeadCustomerData = Object.assign({}, state.LeadCustomerData.address[action.event]);
				state.showAddressView = true;
				state.isAddress_Edit = action.event;
				if (state.LeadCustomerData.address != undefined) {
					state.LeadCustomerData.address[state.isAddress_Edit].address_line_1 = state.LeadCustomerData.address[state.isAddress_Edit].address_line_1.trim();
					state.LeadCustomerData.address[state.isAddress_Edit].is_edit = 1;
					const_var.addressBook[state.isAddress_Edit].is_edit = 1;
				}
			}
			if (action.key == "back") {
				if (
					state.LeadCustomerData.address &&
					state.LeadCustomerData.address.length > 0 &&
					state.LeadCustomerData.address[state.isAddress_Edit] != undefined &&
					state.LeadCustomerData.address[state.isAddress_Edit].is_edit != 1
				) {
					state.LeadCustomerData.address.splice(state.isAddress_Edit, 1);
					const_var.addressBook.splice(state.isAddress_Edit, 1);
				}
				if (
					state.LeadCustomerData.address &&
					state.LeadCustomerData.address.length > 0 &&
					state.LeadCustomerData.address[state.isAddress_Edit] != undefined &&
					state.LeadCustomerData.address[state.isAddress_Edit].is_edit == 1
				) {
					state.LeadCustomerData.address[state.isAddress_Edit] = const_var.TempLeadCustomerData;
				}
				state.showAddressView = false;
				state.displayerrorMessage = {};
			}
			if (action.key == "add") {
				state.showAddressView = true;
				if (state.LeadCustomerData.address != undefined && state.LeadCustomerData.address.length > 0) {
					state.LeadCustomerData.address.push({ address_line_1: "", address_line_2: "", zipcode: "", county: "", state: "", city: "", is_billing: 0, is_installation: 0 });
					const_var.addressBook.push({ new_address_line_1: "", new_address_line_2: "", new_zipcode: "", new_county: "", new_state: "", new_city: "", is_billing: 0, is_installation: 0 });
				} else {
					if (state.LeadCustomerData.address == undefined) {
						state.LeadCustomerData.address = [];
					}
					state.LeadCustomerData.address.push({ address_line_1: "", address_line_2: "", zipcode: "", county: "", state: "", city: "", is_default: 1, is_billing: 1, is_installation: 1 });
					const_var.addressBook.push({ new_address_line_1: "", new_address_line_2: "", new_zipcode: "", new_county: "", new_state: "", new_city: "", is_default: 1, is_billing: 1, is_installation: 1 });
				}
				state.isAddress_Edit = state.LeadCustomerData.address.length > 0 ? state.LeadCustomerData.address.length - 1 : state.LeadCustomerData.address.length;
			}
			if (action.key == "update") {
				state.showAddressView = false;
				state.LeadCustomerData["address"].map((val, index) => {
					if (action.is_Checked != undefined) {
						val[action.is_Checked] = 0;
						const_var.addressBook[index].is_Checked = 0;
						if (action.event == index) {
							val[action.is_Checked] = 1;
							const_var.addressBook[index].is_Checked = 1;
						}
					}
				});
			}
			return {
				...state,
				action
			};
			break;
		case "AddEditAddressRecord":
			if (action.key == "create") {
				validate.onSubmitAddressAddEditForm(action.event);
				action.event.preventDefault();
				state.displayerrorMessage = const_var.displayerrorMessage;
			} else {
				for (let i = 0; i <= action.event.target.length - 1; i++) {
					if (action.event.target[i].name != "") {
						var newKeyName = "new_" + action.event.target[i].name;
						const_var.addressBook[state.isAddress_Edit][newKeyName] = action.event.target[i].value;
					}
				}
				state.LeadCustomerData.address.map((val, index) => {
					if (val.address_line_1 == "" && val.address_line_2 == "" && val.county == "" && val.city == "" && val.state == "" && val.zipcode == "") {
						if (state.LeadCustomerData.address[index].notRemove == undefined || state.LeadCustomerData.address[index].notRemove == false) {
							state.LeadCustomerData.address.splice(index, 1);
						}
					}
				});

				state.showAddressView = false;
			}
			return {
				...state,
				action
			};
			break;
		case "GenrateBuildingDatatoServer":
			if (action.key != "") {
				if (action.event != "") {
					action.event.preventDefault();
				}

				const_var.focusedSection = "";

				params.is_translusant = false;
				params.isShowCenter = false;

				state.is_module_name = const_var.crmSetting.is_module_name;
				state.targetRedirectUrl = const_var.targetRedirectUrl;
				state.targetRedirectUrl.web_url = const_var.crmSetting.web_url;
				state.targetRedirectUrl.form_action = const_var.crmSetting.form_action;
				state.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
				state.targetRedirectUrl.selected_sub_module = const_var.crmSetting.selected_sub_module;
				state.targetRedirectUrl.loggeedincrmflag = state.loggeedincrmflag;
				state.targetRedirectUrl.loggeedincrmflagURL = state.loggeedincrmflagURL;
				state.alertUsedMSG = "";
				state.thankYouForSaveLater = false;
				const_var.controls.target.set(0, params.p_h / 2, 0);
				const_var.camera.position.set(0, params.p_h + 0, 3.25 * params.p_d * 5);
				const_var.controls.update();
				state.returnRespone = "";
				state.showCustomerModal = false;
				state.isShowSuccessOq = true;
				state.i_g_A_y = false;
				if (const_var.checkCaptuareImage != true) {
					const_var.checkIval = 0;
					const_var.i_g_A_y = [];
				}
				const_var.selectedTabKeyForWheel = "capture";

				let checkBodyThyumb = document.querySelector("body");
				if (checkBodyThyumb.classList.contains("activethumb-view")) {
					checkBodyThyumb.classList.remove("active-offset-thumbnail");
					const_var.ClickforPhotosMobile.current.click();
					setTimeout(() => {
						const_var.activeTab = "buildingtypetab";
						cuComponent.TsCeSot("quote", "finalsubmit");
					}, 500);
				} else {
					const_var.activeTab = "buildingtypetab";
					cuComponent.TsCeSot("quote", "finalsubmit");
				}
			} else {
				state.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
				state.returnRespone = action.returnRespone;
			}

			return {
				...state,
				action
			};
		case "handleCommonModal":
			state.is_module_name = const_var.crmSetting.is_module_name;
			if (action.value == "terms_conditions") {
				state.showTermsCondition = true;
			} else {
				if (action.value == "") {
					state.alertUsedMSG = "";
					state.thankYouForSaveLater = false;

					state.showCustomerLeadRecord = false;
					state.showCustomerModal = true;
					state.searchData = {};

					if (const_var.LeadCustomerData != undefined) {
						state.LeadCustomerData = const_var.LeadCustomerData;
						state.LeadCustomerData["is_ActionButton"] = true;
						state.LeadCustomerData["ShowEdit"] =
							const_var.LeadCustomerData && const_var.LeadCustomerData.ShowEdit != undefined
								? const_var.LeadCustomerData.ShowEdit
								: const_var.LeadCustomerData.first_name != undefined && const_var.LeadCustomerData.first_name != ""
									? true
									: false;
					}
					state.leadSourceData = const_var.leadSourceData;
					if (const_var.crmSetting.is_Edit == true) {
						state.searchType = const_var.crmSetting.sub_module == "customer" ? "Customers" : "Leads";
						if (const_var.crmSetting.sub_module == null) {
							const_var.crmSetting.sub_module = state.searchType == "Customers" ? "customer" : "lead";
						}
						if (const_var.leadSourceStateData != "" && Object.keys(const_var.leadSourceStateData).length > 0) {
							state.leadSourceStateData[""] = "Select";

							const_var.stateManufactureDataFromApi.forEach((val, index) => {
								const key = val.state_name.substring(0, 2).toUpperCase();
								state.leadSourceStateData[key] = val.state_name;
							});
						}
						if (const_var.prevModuleType !== undefined && const_var.prevModuleType == "inventory") {
							state.LeadCustomerData.ShowEdit = false;
						}
					} else {
						state.searchType = const_var.crmSetting.is_module_name == "order" ? "Customers" : "Leads";
						if (const_var.crmSetting.selected_sub_module == 1 && const_var.crmSetting.form_action == "create") {
							const_var.crmSetting.sub_module = const_var.crmSetting.sub_module;
						} else {
							const_var.crmSetting.sub_module = state.searchType == "Customers" ? "customer" : "lead";
						}
					}
					state.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
				}
				if (action.value == "close") {
					if (state.showAddressView != undefined && state.showAddressView == true) {
						if (
							state.LeadCustomerData.address &&
							state.LeadCustomerData.address != undefined &&
							state.LeadCustomerData.address.length > 0 &&
							state.isAddress_Edit != undefined &&
							(state.isAddress_Edit != "" || state.isAddress_Edit == 0) &&
							state.LeadCustomerData.address[state.isAddress_Edit] != undefined
						) {
							if (state.LeadCustomerData.address[state.isAddress_Edit].is_edit != undefined && state.LeadCustomerData.address[state.isAddress_Edit].is_edit == 1) {
								state.LeadCustomerData.address[state.isAddress_Edit] = const_var.TempLeadCustomerData;
							} else {
								state.LeadCustomerData.address.pop();
							}
							state.showAddressView = false;
						}
					}

					state.alertUsedMSG = "";
					state.thankYouForSaveLater = false;
					state.showCustomerLeadRecord = false;
					state.showCustomerModal = false;
					state.showTermsCondition = false;

					state.searchData = {};
					state.isShowSuccessOq = false;
					state.LeadCustomerData.ShowEdit = false;
					const_var.proceedToMobileSave = false;

					state.searchType = const_var.crmSetting.is_module_name == "order" ? "Customers" : "Leads";
				}
				if (action.value != "close" && action.value != "") {
					if (const_var.crmSetting.is_Edit != true && const_var.crmSetting.sub_module_id == "") {
						state.LeadCustomerData = {};
					}
					state.showCustomerLeadRecord = false;

					const tempObj = action.value.reduce((acc, item) => {
						acc[item.source_slug] = item.source_name;
						return acc;
					}, {});
					state.leadSourceData = tempObj;

					state.leadSourceStateData[""] = "Select";

					const_var.stateManufactureDataFromApi.forEach((val, index) => {
						const key = val.state_name.substring(0, 2).toUpperCase();
						state.leadSourceStateData[key] = val.state_name;
					});

					Object.entries(state.leadSourceData).map((val, index) => {
						if (index == 0) {
							state.LeadCustomerData.lead_source = val[1];
							const_var.LeadCustomerData["lead_source"] = val[1];
						}
						if (val[0] == "call_in") {
							state.LeadCustomerData.lead_source = val[0];
							const_var.LeadCustomerData["lead_source"] = val[0];
						}
					});

					const_var.leadSourceData = tempObj;
					state.searchData = {};

					state.searchType = const_var.crmSetting.is_module_name == "order" ? "Customers" : "Leads";
				}
			}

			state.i_g_A_y = true;
			return {
				...state,
				action
			};
			break;
		case "commonsActionforLeadCustomer":
			if (action.key == "Search") {
				state.searchType = action.value;
				state.showInstallationAddressDetails = false;
				if (state.searchType == "Customers" && const_var.crmSetting.is_module_name == "quote") {
					state.addCustomerData = true;
				} else {
					state.addCustomerData = false;
				}
				if ((state.searchTempData !== undefined && state.searchTempData !== undefined && state.searchTempData.length > 0) || state.recordFoundFlag == true) {
					state.LeadCustomerData.first_name = "";
					state.LeadCustomerData.last_name = "";
					state.LeadCustomerData.phone_no = "";
					state.LeadCustomerData.mobile_no = "";
					state.LeadCustomerData.email = "";
					state.LeadCustomerData.address = [];
					state.LeadCustomerData.lead_source = [0];
					state.LeadCustomerData.billing_address_line_1 = "";
					state.LeadCustomerData.billing_address_line_2 = "";
					state.LeadCustomerData.billing_city = "";
					state.LeadCustomerData.billing_county = "";
					state.LeadCustomerData.billing_state = "Select";
					state.LeadCustomerData.billing_zipcode = "";
					state.LeadCustomerData.shipping_address_line_1 = "";
					state.LeadCustomerData.shipping_address_line_2 = "";
					state.LeadCustomerData.shipping_city = "";
					state.LeadCustomerData.shipping_county = "";
					state.LeadCustomerData.shipping_state = "Select";
					state.LeadCustomerData.shipping_zipcode = "";
					state.searchTempData = [];
					state.recordFoundFlag = false;
					const_var.crmSetting.sub_module_id = "";
					state.search_temp_lead_customer = state.search_lead_customer;
					state.searchData = {};
					state.editId = 0;
					state.search_lead_customer = "";
					state.editAddressShow = false;
					state.addAddressShow = true;
					state.showInstallationAddressDetails = false;
					state.LeadCustomerData.ShowEdit = false;
				}
				state.LeadCustomerData = state.LeadCustomerData != undefined ? state.LeadCustomerData : {};
				document.getElementById("configuration").reset();
				state.searchData = {};
				state.showCustomerLeadRecord = false;
				const_var.crmSetting.sub_module = state.searchType == "Customers" ? "customer" : "lead";
				state.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
			}
			if (action.key == "Search_Value") {
				state.search_lead_customer = action.value;
			}
			if (action.key == "same_as") {
				state.showInstallationAddressDetails = !state.showInstallationAddressDetails;
				state.LeadCustomerData.is_Action = false;
			}
			if (action.key == "change_klink_text") {
				state.copyKlinkText = "Copied";
			}
			if (action.key == "closeInfo") {
				const_var.infoMessage = false;
			}

			return {
				...state,
				action
			};
			break;
		case "EditCustomerLeadRecord":
			if (action.key === "editAdd") {
				if (state.LeadCustomerData?.address?.length > 0) {
					let filterAdd = state.LeadCustomerData.address.filter((add) => {
						return add.address_line_1 == action.data.address_line_1 && add.address_line_2 == action.data.address_line_2 && add.zipcode == action.data.zipcode && add.state == action.data.state;
					});
					if (action.from === "billing") {
						state.LeadCustomerData.billing_address_line_1 = filterAdd[0].address_line_1;
						state.LeadCustomerData.billing_address_line_2 = filterAdd[0].address_line_2;
						state.LeadCustomerData.billing_city = filterAdd[0].city;
						state.LeadCustomerData.billing_county = filterAdd[0].county;
						state.LeadCustomerData.billing_state = filterAdd[0].state;
						state.LeadCustomerData.billing_zipcode = filterAdd[0].zipcode;
					}
					if (action.from === "installation") {
						state.LeadCustomerData.shipping_address_line_1 = filterAdd[0].address_line_1;
						state.LeadCustomerData.shipping_address_line_2 = filterAdd[0].address_line_2;
						state.LeadCustomerData.shipping_city = filterAdd[0].city;
						state.LeadCustomerData.shipping_county = filterAdd[0].county;
						state.LeadCustomerData.shipping_state = filterAdd[0].state;
						state.LeadCustomerData.shipping_zipcode = filterAdd[0].zipcode;
					}
					state.editAddressIndex = action.index;
					state.editAddressType = action.from;
					state.editAddressShow = true;
				} else {
					state.LeadCustomerData.billing_address_line_1 = "";
					state.LeadCustomerData.billing_address_line_2 = "";
					state.LeadCustomerData.billing_city = "";
					state.LeadCustomerData.billing_county = "";
					state.LeadCustomerData.billing_state = "Select";
					state.LeadCustomerData.billing_zipcode = "";
					state.LeadCustomerData.shipping_address_line_1 = "";
					state.LeadCustomerData.shipping_address_line_2 = "";
					state.LeadCustomerData.shipping_city = "";
					state.LeadCustomerData.shipping_county = "";
					state.LeadCustomerData.shipping_state = "Select";
					state.LeadCustomerData.shipping_zipcode = "";
				}
				state.searchTempData = state.searchData;
				state.searchData = {};
				state.search_lead_customer = "";
				state.editAddressShow = true;
				state.LeadCustomerData.ShowEdit = false;
			}
			return {
				...state,
				action
			};
			break;
		case "AddCustomerLeadRecord":
			if (action.key == "create") {
				validate.onSubmitEditForm(action.event);
				action.event.preventDefault();
				state.displayerrorMessage = const_var.displayerrorMessage;
				const_var.checkValidate = false;
				let checkError = Object.values(const_var.displayerrorMessage);
				checkError?.length > 0 &&
					checkError.map((err) => {
						if (err != "") {
							const_var.checkValidate = true;
							state.showMoreWithErr = true;
						}
					});
			}
			if (action.key == "save") {
				let temp = const_var;
				let checkValidateIssue = true;
				if (const_var.LeadCustomerData != undefined || const_var.LeadCustomerData != "") {
					state.LeadCustomerData = const_var.LeadCustomerData;
				}
				for (let i = 0; i <= action.event.target.length - 1; i++) {
					if (action.event.target[i].name != "") {
						if (state.displayerrorMessage[action.event.target[i].name] != "" && state.displayerrorMessage[action.event.target[i].name] != undefined) {
							checkValidateIssue = false;
						}
					}
					var arr = [{ key: action.event.target[i].name, value: action.event.target[i].value }];
					state.LeadCustomerData[arr[0].key] = arr[0].value;
					state.LeadCustomerPostData[arr[0].key] = arr[0].value;
				}

				let shippingAddress = {
					address_line_1: state.LeadCustomerData.shipping_address_line_1,
					address_line_2: state.LeadCustomerData.shipping_address_line_2,
					city: state.LeadCustomerData.shipping_city,
					county: state.LeadCustomerData.shipping_county,
					state: state.LeadCustomerData.shipping_state,
					zipcode: state.LeadCustomerData.shipping_zipcode,
					is_billing: 0,
					is_default: 0,
					is_installation: state.LeadCustomerData?.address?.length > 0 ? 0 : 1
				};
				let billingAddress = {
					address_line_1: state.LeadCustomerPostData.billing_address_line_1,
					address_line_2: state.LeadCustomerPostData.billing_address_line_2,
					city: state.LeadCustomerPostData.billing_city,
					county: state.LeadCustomerPostData.billing_county,
					state: state.LeadCustomerPostData.billing_state,
					zipcode: state.LeadCustomerPostData.billing_zipcode,
					is_billing: state.LeadCustomerData?.address?.length > 0 ? 0 : 1,
					is_default: 0,
					is_installation: 0
				};

				if ((state.editAddressShow === false && temp.crmSetting.is_Edit === false) || state.LeadCustomerData?.address?.length == 0) {
					state.LeadCustomerData.address = state.LeadCustomerData?.address?.length > 0 ? state.LeadCustomerData.address : [];

					if (state.showInstallationAddressDetails === false) {
						if (
							shippingAddress.address_line_1 !== undefined ||
							shippingAddress.address_line_2 !== undefined ||
							shippingAddress.city !== undefined ||
							shippingAddress.county !== undefined ||
							shippingAddress.state !== undefined ||
							shippingAddress.zipcode !== undefined
						) {
							state.LeadCustomerData.address.push(shippingAddress);
						}
						if (
							billingAddress.address_line_1 !== undefined ||
							billingAddress.address_line_2 !== undefined ||
							billingAddress.city !== undefined ||
							billingAddress.county !== undefined ||
							billingAddress.state !== undefined ||
							billingAddress.zipcode !== undefined
						) {
							state.LeadCustomerData.address.push(billingAddress);
						}
					} else {
						shippingAddress.is_billing = 1;
						state.LeadCustomerData.address.push(shippingAddress);
					}
				} else if (temp.crmSetting.is_Edit === true && state.LeadCustomerData?.address?.length > 0) {
					if (state.showInstallationAddressDetails === false) {
						if (
							shippingAddress.address_line_1 !== undefined ||
							shippingAddress.address_line_2 !== undefined ||
							shippingAddress.city !== undefined ||
							shippingAddress.county !== undefined ||
							shippingAddress.state !== undefined ||
							shippingAddress.zipcode !== undefined
						) {
							state.LeadCustomerData.address.push(shippingAddress);
						}
						if (
							billingAddress.address_line_1 !== undefined ||
							billingAddress.address_line_2 !== undefined ||
							billingAddress.city !== undefined ||
							billingAddress.county !== undefined ||
							billingAddress.state !== undefined ||
							billingAddress.zipcode !== undefined
						) {
							state.LeadCustomerData.address.push(billingAddress);
						}
					} else {
						shippingAddress.is_billing = 1;
						state.LeadCustomerData.address.push(shippingAddress);
					}
				}
				delete state.LeadCustomerData["shipping_address_line_1"];
				delete state.LeadCustomerData["shipping_address_line_2"];
				delete state.LeadCustomerData["shipping_city"];
				delete state.LeadCustomerData["shipping_state"];
				delete state.LeadCustomerData["shipping_zipcode"];
				delete state.LeadCustomerData["billing_address_line_1"];
				delete state.LeadCustomerData["billing_address_line_2"];
				delete state.LeadCustomerData["billing_city"];
				delete state.LeadCustomerData["billing_state"];
				delete state.LeadCustomerData["billing_zipcode"];
				if (const_var.crmSetting.is_module_name == "quote" && state.searchType == "Customers") {
					state.searchType = "Leads";
				}
				state.LeadCustomerData["ShowEdit"] = checkValidateIssue;
				state.LeadCustomerData["api_token"] = const_var.crmSetting.api_token;
				const_var.LeadCustomerData = state.LeadCustomerData;
				state.editAddressIndex = null;
				state.editAddressType = "";

				state.searchTempData = [];
				state.recordFoundFlag = false;
			}
			if (action.key == "billing_create") {
				validate.onSubmitEditForm(action.event);
				action.event.preventDefault();
				state.displayerrorMessage = const_var.displayerrorMessage;
			}
			if (action.key == "billing") {
				let same_asData = "";
				let checkValidateIssue = false;
				if (state.showAddressView != undefined && state.showAddressView == true) {
					if (
						state.LeadCustomerData.address &&
						state.LeadCustomerData.address != undefined &&
						state.LeadCustomerData.address.length > 0 &&
						state.isAddress_Edit != undefined &&
						(state.isAddress_Edit != "" || state.isAddress_Edit == 0) &&
						state.LeadCustomerData.address[state.isAddress_Edit] != undefined
					) {
						if (state.LeadCustomerData.address[state.isAddress_Edit].is_edit != undefined && state.LeadCustomerData.address[state.isAddress_Edit].is_edit == 1) {
							state.LeadCustomerData.address[state.isAddress_Edit] = const_var.TempLeadCustomerData;
						} else {
							state.LeadCustomerData.address.pop();
						}
						state.showAddressView = false;
					}
				}

				for (let i = 0; i <= action.event.target.length - 1; i++) {
					if (action.event.target[i].name == "first_name") {
						state.LeadCustomerPostData["first_name"] = action.event.target[i].value;
					} else if (action.event.target[i].name == "last_name") {
						state.LeadCustomerPostData["last_name"] = action.event.target[i].value;
					} else if (action.event.target[i].name == "email") {
						state.LeadCustomerPostData["email"] = action.event.target[i].value;
					} else if (action.event.target[i].name == "phone_no") {
						state.LeadCustomerPostData["phone_no"] = action.event.target[i].value;
					} else if (action.event.target[i].name == "mobile_no") {
						state.LeadCustomerPostData["mobile_no"] = action.event.target[i].value;
					}

					if (action.event.target[i].name != "" && state.displayerrorMessage[action.event.target[i].name] != "" && state.displayerrorMessage[action.event.target[i].name] != undefined) {
						checkValidateIssue = true;
					}
				}
				state.editAddressShow = false;
				state.showCustomerLeadRecord = checkValidateIssue;
				if (checkValidateIssue != true) {
					state.LeadCustomerData = { ...state.LeadCustomerData, ...state.LeadCustomerPostData };
					state.LeadCustomerData["is_Action"] = true;
					const_var.crmSetting.sub_module_id = state.LeadCustomerData.u_id != undefined ? state.LeadCustomerData.u_id : const_var.crmSetting.sub_module_id;
					if (const_var.crmSetting.selected_sub_module == 1 && const_var.crmSetting.form_action == "create") {
						const_var.crmSetting.sub_module = const_var.crmSetting.sub_module;
					} else {
						const_var.crmSetting.sub_module = const_var.crmSetting.is_Edit == true ? const_var.crmSetting.sub_module : state.searchType == "Customers" ? "customer" : "lead";
					}
					state.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
					const_var.LeadCustomerData = { ...state.LeadCustomerData, ...state.LeadCustomerPostData };
				}

				state.showCustomerModal = checkValidateIssue;
				if (checkValidateIssue == false) {
					state.leadSourceData = {};
					state.searchData = {};
					state.searchType = "Leads";
				}
			}
			if (action.key == "back") {
				if (state.showAddressView != undefined && state.showAddressView == true) {
					if (
						state.LeadCustomerData.address &&
						state.LeadCustomerData.address != undefined &&
						state.LeadCustomerData.address.length > 0 &&
						state.isAddress_Edit != undefined &&
						(state.isAddress_Edit != "" || state.isAddress_Edit == 0) &&
						state.LeadCustomerData.address[state.isAddress_Edit] != undefined
					) {
						if (state.LeadCustomerData.address[state.isAddress_Edit].is_edit != undefined && state.LeadCustomerData.address[state.isAddress_Edit].is_edit == 1) {
							state.LeadCustomerData.address[state.isAddress_Edit] = const_var.TempLeadCustomerData;
						} else {
							state.LeadCustomerData.address.pop();
						}
						state.showAddressView = false;
					}
				}
				state.searchType = const_var.crmSetting.is_module_name == "order" ? "Customers" : "Leads";
				state.is_module_name = const_var.crmSetting.is_module_name;
				state.LeadCustomerData = {};
				const_var.LeadCustomerData = {};
				state.LeadCustomerPostData = {};
				state.showAddressView = false;

				if (state.searchTempData && state.searchTempData.length > 0) {
					state.searchData = state.searchTempData;
					state.search_lead_customer = state.search_temp_lead_customer;
				}

				state.showCustomerLeadRecord = false;

				if (const_var.crmSetting.sub_module == "" && const_var.checkPickThisBuilding) {
					const_var.crmSetting.sub_module = state.searchType == "Customers" ? "customer" : "lead";
				}
			}
			if (action.key == "openAdd") {
				state.searchTempData = state.searchData;
				state.search_temp_lead_customer = state.search_lead_customer;
				state.searchData = {};
				state.editId = 0;
				state.search_lead_customer = "";
				state.editAddressShow = false;
				state.addAddressShow = true;
				state.showInstallationAddressDetails = false;
				state.LeadCustomerData.ShowEdit = false;
				state.LeadCustomerData.billing_address_line_1 = "";
				state.LeadCustomerData.billing_address_line_2 = "";
				state.LeadCustomerData.billing_county = "";
				state.LeadCustomerData.billing_state = "Select";
				state.LeadCustomerData.billing_zipcode = "";
				state.LeadCustomerData.billing_city = "";
				state.LeadCustomerData.shipping_address_line_1 = "";
				state.LeadCustomerData.shipping_address_line_2 = "";
				state.LeadCustomerData.shipping_county = "";
				state.LeadCustomerData.shipping_state = "Select";
				state.LeadCustomerData.shipping_zipcode = "";
				state.LeadCustomerData.shipping_city = "";
			}
			if (action.key == "detail_page") {
				state.LeadCustomerData.ShowEdit = true;
			}
			return {
				...state,
				action
			};
			break;
		case "readyCaptured":
			if (action.event === null || action.event === undefined) {
				const_var.checkValidate = false;
			}
			validate.onSubmitEditForm(action.event);
			const_var.i_g_A_y = [];
			action.event.preventDefault();
			return {
				...state,
				action
			};
			break;

		case "onSearchRecords":
			action.event.preventDefault();
			state.searchData = action.value.data.length > 0 ? action.value.data : ["No"];
			state.recordFoundFlag = action.value.data.length > 0 ? true : false;
			state.search_lead_customer = action.search_text;
			const_var.checkValidate = false;
			if (action.value.states != undefined) {
				const_var.leadSourceStateData = action.value.states;
				state.leadSourceStateData[""] = "Select";
				action.value.states.map((val, key) => {
					state.leadSourceStateData[val.code] = val.name;
				});
			}

			return {
				...state,
				action
			};
			break;
		case "handleCustomerData":
			if (action.eventType != "back") {
				if (action.row.email == "") {
					action.row.email = "";
				}
				if (action.row.email_2 == "") {
					action.row.email_2 = "";
				}
				var newPhoneNumber = "";
				if (action.row.phone_no != "" && newPhoneNumber == "") {
					newPhoneNumber = action.row.phone_no;
				}
				if (action.row.mobile_no != "" && newPhoneNumber == "") {
					newPhoneNumber = action.row.mobile_no;
				}
				if (action.row.phone_no_2 != "" && newPhoneNumber == "") {
					newPhoneNumber = action.row.phone_no_2;
				}

				state.displayerrorMessage = "";
				const_var.displayerrorMessage = {};
				action.row.ShowEdit = true;
				state.LeadCustomerData = action.row;
				const_var.check_siding_material_price = true;
				if (action.event == "" && state.LeadCustomerData.taxPersentage != undefined && state.LeadCustomerData.taxPersentage != "" && params.tax_exempt == false) {
					const_var.tax.percentage = state.LeadCustomerData.taxPersentage;
					const_var.tax.tax_value = const_var.tax.percentage;
					if (isNaN(parseInt(const_var.tax.amount)) == true) {
						const_var.tax.amount = 0;
					}
					if (state.LeadCustomerData.address.length == 0) {
						const_var.holdTaxArrResp = [];
						const_var.MoreTaxinputs = [];
					}
					cuBuilding.cP();
				} else {
					const_var.tax.percentage = 0;
					const_var.tax.tax_value = const_var.tax.percentage;
					const_var.tax.amount = 0;
					if (isNaN(parseInt(const_var.tax.amount)) == true) {
						const_var.tax.amount = 0;
					}
					if (state.LeadCustomerData.address.length == 0) {
						const_var.holdTaxArrResp = [];
						const_var.post_data.building.tax = [];
						const_var.MoreTaxinputs = [];
					}
					cuBuilding.cP();
				}
				if (const_var.leadSourceStateData != "" && Object.keys(const_var.leadSourceStateData).length > 0) {
					state.leadSourceStateData[""] = "Select";
					const_var.crmSetting.sub_module_id = state.LeadCustomerData.u_id;
					const_var.leadSourceStateData.map((val, key) => {
						state.leadSourceStateData[val.code] = val.name;
					});
				}
				params.tax_zipcode = "";
				state.LeadCustomerData["address"] = state.LeadCustomerData.address;
				state.LeadCustomerData.address.map((val, index) => {
					state.LeadCustomerData["address"][index].notRemove = true;
					const_var.addressBook.push({
						new_address_line_1: val.address_line_1,
						new_address_line_2: val.address_line_2,
						new_zipcode: val.zipcode,
						new_state: val.state,
						new_city: val.city,
						new_county: val.county
					});
					if (action.event == "") {
						if (val.is_default == 1) {
							state.LeadCustomerData["showZip"] = val.zipcode;
							params.tax_zipcode = val.zipcode;
							const_var.LeadCustomerData.showZip = val.zipcode;
						}
					} else {
						if (val.is_default == 1) {
							state.LeadCustomerData["showZip"] = val.zipcode;
							params.tax_zipcode = val.zipcode;
							const_var.LeadCustomerData.showZip = val.zipcode;
						}
					}
				});

				state.LeadCustomerData["billing_address_line_1"] = state.LeadCustomerData["shipping_address_line_1"] = state.LeadCustomerData.address_line_1;
				state.LeadCustomerData["billing_address_line_2"] = state.LeadCustomerData["shipping_address_line_2"] = state.LeadCustomerData.address_line_2;
				state.LeadCustomerData["billing_city"] = state.LeadCustomerData["shipping_city"] = state.LeadCustomerData.city;
				state.LeadCustomerData["billing_state"] = state.LeadCustomerData["shipping_state"] = state.LeadCustomerData.state;
				state.LeadCustomerData["billing_country"] = state.LeadCustomerData["shipping_country"] = state.LeadCustomerData.county;
				state.LeadCustomerData["billing_zipcode"] = state.LeadCustomerData["shipping_zipcode"] = state.LeadCustomerData.zipcode;

				if (const_var.crmSetting.selected_sub_module == 1 && const_var.crmSetting.form_action == "create") {
					const_var.crmSetting.sub_module = const_var.crmSetting.sub_module;
				} else {
					const_var.crmSetting.sub_module = state.searchType == "Customers" ? "customer" : "lead";
				}
				state.LeadCustomerData.lead_source = state.searchType == "Customers" ? action.row.source : action.row.lead_source;
				const_var.LeadCustomerData = state.LeadCustomerData;
				const_var.crmSetting.sub_module_id = action.row.u_id;
				state.targetRedirectUrl.sub_module = const_var.crmSetting.sub_module;
			} else {
				state.LeadCustomerData.ShowEdit = false;
			}
			return {
				...state,
				action
			};
		case "handleCustomerDataWithAPI":
			if (action.event == "") {
				state.LeadCustomerData.taxPersentage = action.responseData != "" ? action.responseData.data[0] : const_var.tax.percentage;
				if (action.responseData.tax_data == undefined || action.responseData.tax_data == null) {
					const_var.MoreTaxinputs = [];
				}
				const_var.holdTaxArrResp = [];
				if (action.responseData.tax_data != undefined && action.responseData.tax_data != "") {
					if (const_var.MoreTaxinputs.length > 0) {
						const_var.MoreTaxinputs = [];
					}
					let i = 0;
					Object.entries(action.responseData.tax_data)
						.sort()
						.map(([value, key]) => {
							if (key != 0) {
								if (i == 0) {
									state.LeadCustomerData.taxPersentage = key;
									const_var.tax.name = const_var.taxTypeName[value];
								} else {
									const_var.MoreTaxinputs.push({ amount: 0, name: const_var.taxTypeName[value], percentage: key, type: "per" });
								}
								const_var.holdTaxArrResp?.push({ amount: 0, name: const_var.taxTypeName[value], percentage: key, type: "per", tax_value: key });
								i++;
							}
						});
					if (const_var.post_data?.building?.tax) {
						const_var.post_data.building.tax = const_var.holdTaxArrResp;
					}
					if (const_var.holdTaxArrResp.length == 0) {
						const_var.post_data.building.tax = [];
						const_var.MoreTaxinputs = [];
					}
				}
				const_var.tax.percentage = state.LeadCustomerData.taxPersentage;
				const_var.tax.tax_value = const_var.tax.percentage;
				if (action.responseData?.data?.length == 0) {
					const_var.post_data.building.tax = [];
					const_var.MoreTaxinputs = [];
					const_var.holdTaxArrResp = [];
				}
				if (isNaN(parseInt(const_var.tax.amount)) == true) {
					const_var.tax.amount = 0;
				}
				if (params.tax_exempt == true) {
					const_var.tax.percentage = 0;
					const_var.tax.tax_value = const_var.tax.percentage;
					const_var.tax.amount = 0;
					params.tax_zipcode = "";
					if (isNaN(parseInt(const_var.tax.amount)) == true) {
						const_var.tax.amount = 0;
					}
				}
				cuBuilding.cP();
			}
			return {
				...state,
				action
			};
		case "CloseEditemial":
			state.showEditEmail = false;
			return {
				...state,
				action
			};

		case "CheckEditQuoteAlertBox":
			state.editOrderQuoteAlertBox = !state.editOrderQuoteAlertBox;
			state.redirectvalue = action.value;
			if (action.key == "editwithcrm") {
				if (state.redirectcrmflag == true) {
					window.location.href = "https://www.example.com";
				} else {
					window.open(state.redirectvalue, "_blank");
				}
			}

			return {
				...state,
				action
			};
	}
	return newState;
};
export default leadcustomerReducer;
